import styled from 'styled-components';
import { media, Row } from '@simplywallst/ui-core';

interface WrapperProps {
  hidden?: boolean;
  height?: number | string;
  heightMdDown?: number | string;
  heightSmDown?: number | string;
  scrollOnOverflow?: boolean;
  showDefaultMode?: boolean;
}
export const Wrapper = styled('div')<WrapperProps>`
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  overflow-y: ${({ scrollOnOverflow }) => (scrollOnOverflow ? 'auto' : 'none')};
  ${({ height }) =>
    typeof height === 'number' ? `height: ${height}px;` : `height: ${height}`}
  ${media.mdDown`
  ${({ heightMdDown }) =>
    typeof heightMdDown === 'number'
      ? `height: ${heightMdDown}px;`
      : `height: ${heightMdDown}`}
	`}
  ${media.smDown`
  ${({ heightSmDown }) =>
    typeof heightSmDown === 'number'
      ? `height: ${heightSmDown}px;`
      : `height: ${heightSmDown}`}
	`}
  ${({ showDefaultMode }) => showDefaultMode && 'opacity: 0.2'};
`;
export const Container = styled('div')`
  position: relative;
`;
export const DefaultOverlay = styled(Row)`
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  text-align: center;
  ${({ theme }) => theme.typography.smallStrong}
`;

export const ActionsPlaceHolder = styled('div')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  height: ${({ theme }) => theme.x4spacePx}px;
  width: ${({ theme }) => theme.x4spacePx}px;
`;
